// Dependencies
import { all, call, takeEvery, fork, put } from "@redux-saga/core/effects";

// Action Types
import {
    DEVICES_COMMON_SEARCH_DEVICES
} from 'Redux/actionTypes';

// Actions
import {
    devicesCommonGetDevicesResult,
} from 'Redux/actions';

// Helpers
import { clientQuery } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';

function* searchDevices({ payload }) {
    try {
        let { devices } = payload;
        let resultDevices = [];
        let QUERY_SEARCH_DEVICES = `
        query ($conditions: [UnitSearchInput], $sort: [UnitSortInput], $limit: Int, $offset: Int){
            Devices: searchUnits(conditions: $conditions sort: $sort limit: $limit offset: $offset ){
              total
              items {
                id
                label
                imei
                esn
                deviceModel {
                  id
                  name
                  manufacturer {
                      id
                      name
                  }
                }
                configStatus
                unitConfig {
                  unitId
                  configVersion
                  scriptVersion
                  pulsCustomerId
                  pulsGroup
                  movingFrequency
                  stoppedFrequency
                  password
                  cameraInfo
                  cameraInfoUpdated
                  simState
                  firmwareId
                  hardwareVersion
                  cameraConfig
                  }
              }
            }
          }
        `;

        if (devices.length > 0) {

            let criteria = {
                conditions: [
                    { terms: devices, fields: ["imei", "esn"], exact: true },
                ],
                offset: 0,
                limit: devices.length
            };

            const dataDevices = yield call(
                clientQuery,
                QUERY_SEARCH_DEVICES,
                criteria,
                endpoints.GRAPHQL_GENERAL
            );

            resultDevices = dataDevices.Devices.items
        } else {
            resultDevices = [];
        }

        

        yield put(devicesCommonGetDevicesResult({ data: resultDevices, error: null }));


    } catch (exc) {
        yield put(devicesCommonGetDevicesResult({ data: exc.data, error: exc }));
    }
}


function* watchMethods() {
    yield takeEvery(DEVICES_COMMON_SEARCH_DEVICES, searchDevices);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}